import { Link } from "react-router-dom";
import { Mail, Phone, MessageCircle, ArrowUpRight } from "lucide-react";
import { COMPANY, SERVICES } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#1f1f22] bg-[#08080A] pt-24 pb-10 relative overflow-hidden">
      <div className="glow-spot" style={{ width: 600, height: 600, background: "#DC1F33", top: "-200px", right: "-200px" }} />
      <div className="container-x relative">
        <div className="grid lg:grid-cols-[1.4fr_1fr_1fr_1fr] gap-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="/images/logo.png"
                alt="Jeet IT Services"
                className="w-12 h-12 object-contain"
              />
              <div>
                <div className="font-display text-white font-bold uppercase tracking-tight">Jeet IT Services</div>
                <div className="label-mono">Premium Engineering Studio / Since 2016</div>
              </div>
            </div>
            <p className="text-zinc-400 text-[15px] leading-relaxed max-w-md mb-8">
              Engineering scalable software, web platforms and cloud infrastructure for businesses worldwide. Remote-first, time-zone aligned, results obsessed.
            </p>
            <Link to="/contact" data-testid="footer-cta" className="btn-primary">
              Start a Project <ArrowUpRight size={16} />
            </Link>
          </div>

          <div>
            <div className="label-mono mb-5">Services</div>
            <ul className="space-y-3">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.slug}>
                  <Link
                    to="/services"
                    data-testid={`footer-service-${s.slug}`}
                    className="text-zinc-300 hover:text-[#DC1F33] transition-colors text-sm"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="label-mono mb-5">Company</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" data-testid="footer-link-about" className="text-zinc-300 hover:text-[#DC1F33]">About</Link></li>
              <li><Link to="/portfolio" data-testid="footer-link-portfolio" className="text-zinc-300 hover:text-[#DC1F33]">Portfolio</Link></li>
              <li><Link to="/services" data-testid="footer-link-services" className="text-zinc-300 hover:text-[#DC1F33]">Services</Link></li>
              <li><Link to="/contact" data-testid="footer-link-contact" className="text-zinc-300 hover:text-[#DC1F33]">Contact</Link></li>
            </ul>
          </div>

          <div>
            <div className="label-mono mb-5">Contact</div>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="flex items-center gap-3 text-zinc-300 hover:text-[#DC1F33]">
                  <Mail size={14} /> {COMPANY.email}
                </a>
              </li>
              <li>
                <a href={`tel:${COMPANY.phoneRaw}`} data-testid="footer-phone" className="flex items-center gap-3 text-zinc-300 hover:text-[#DC1F33]">
                  <Phone size={14} /> {COMPANY.phone}
                </a>
              </li>
              <li>
                <a href={COMPANY.whatsapp} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 text-zinc-300 hover:text-[#DC1F33]">
                  <MessageCircle size={14} /> WhatsApp Chat
                </a>
              </li>
              <li className="text-zinc-500 mt-3">{COMPANY.address}</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-[#1f1f22] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="label-mono">© {new Date().getFullYear()} Jeet IT Services — All rights reserved.</div>
          <div className="label-mono">Designed & engineered for the world 🌍</div>
        </div>
      </div>
    </footer>
  );
}
